import { render, staticRenderFns } from "./SitesCreate.vue?vue&type=template&id=b84de642"
import script from "./SitesCreate.vue?vue&type=script&lang=js"
export * from "./SitesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports